










import Vue from 'vue';
import { EventBus } from '@/event-bus';
import * as accountSettingsTools from '@/components/account-settings-tools';
import * as accountTools from '@/components/account-components/account-tools';
import { Questions } from '@/components/tasks-components';
import * as authTools from '@/components/auth-tools';
import { ViewAccountNumberOverlay } from '@/components/account-settings-components/hsa-settings-components';
import * as printTools from '@/components/print-components';
import { UpdateDocumentDetail } from '@/components/my-documents-components/update-document-detail-component';
import { RemoveDocument } from '@/components/my-documents-components/remove-document-component';
import { MatchToTransaction } from '@/components/my-documents-components/match-to-transaction-component';
import { ChooseFileFromVault } from '@/components/my-documents-components/my-documents-modal';

interface Data {
  componentToLoad: any;
  params: any;
}

export default Vue.extend({
  name: 'OverlayWrapper',
  data(): Data {
    return {
      componentToLoad: null,
      params: null,
    };
  },
  mounted() {
    EventBus.$on('openOverlayWrapper', this.openOverlayWrapper);
    EventBus.$on('closeOverlayWrapper', this.closeOverlayWrapper);
  },
  watch: {
    $route() {
      if (this.componentToLoad !== 'Questions') {
        EventBus.$emit('closeOverlayWrapper');
      }
    },
  },
  methods: {
    openOverlayWrapper(component, params): void {
      this.params = params;
      this.componentToLoad = component;
    },
    closeOverlayWrapper(goToRoute): void {
      if (this.params && this.params.routeAfterClose && goToRoute) {
        this.$router.push(this.params.routeAfterClose);
      }

      this.params = null;
      this.componentToLoad = null;
    },
  },
  components: {
    ...accountTools,
    ...accountSettingsTools,
    Questions,
    ...authTools,
    ViewAccountNumberOverlay,
    ...printTools,
    UpdateDocumentDetail,
    RemoveDocument,
    MatchToTransaction,
    ChooseFileFromVault,
  },
});
